document.addEventListener('DOMContentLoaded', () => {
  const frames = document.querySelectorAll('.frame')
  const heroCollage = document.querySelector('.hero-collage')

  let z = 1

  // Helper function to get random number between min and max
  const random = (min, max) => Math.random() * (max - min) + min

  frames.forEach((frame) => {
    const corner = frame.querySelector('.corner')
    const photograph = frame.querySelector('.photograph')
    const img = photograph.querySelector('img')

    // Detect if mobile screen
    const isMobile = window.innerWidth <= 768

    const initializeFrame = () => {
      // Get the dimensions of the hero-collage container fresh each time
      // This ensures we have the correct dimensions after layout is complete
      const containerWidth = heroCollage.clientWidth
      const containerHeight = heroCollage.clientHeight

      // Safety check: don't initialize if container dimensions are invalid
      if (containerWidth === 0 || containerHeight === 0) {
        console.warn('Container dimensions not ready, retrying...')
        setTimeout(initializeFrame, 100)
        return
      }
      // Set random initial size (different ranges for mobile vs desktop)
      // Generate random values inside initializeFrame to ensure unique values each time
      const minWidth = isMobile ? 75 : 140
      const maxWidth = isMobile ? 100 : 200
      const randomWidth = random(minWidth, maxWidth)

      let frameWidth = randomWidth
      let frameHeight = randomWidth

      if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
        const aspectRatio = img.naturalWidth / img.naturalHeight
        const randomHeight = randomWidth / aspectRatio

        frame.style.width = randomWidth + 'px'
        frame.style.height = randomHeight + 'px'

        // Account for padding in frame size calculations
        const isIllustration = frame.classList.contains('illustration')
        const padding = isIllustration ? 0 : (isMobile ? 16 : 24) // 8px or 12px padding on each side
        frameWidth = randomWidth + padding
        frameHeight = randomHeight + padding
      }

      // Set random rotation between -7deg and 10deg (but not for illustrations)
      const isIllustration = frame.classList.contains('illustration')
      if (!isIllustration) {
        const randomRotation = random(-7, 10)
        frame.style.transform = `rotate(${randomRotation}deg)`
      }

      // Calculate position after sizing and rotation to ensure frame stays within bounds
      // Add margin to keep images more centered and prevent edge cropping
      // Use smaller margin on mobile to give more space for positioning
      const margin = isMobile ? 5 : 15 // pixels of margin from edges

      // Calculate available space for positioning
      const availableWidth = containerWidth - frameWidth - (margin * 2)
      const availableHeight = containerHeight - frameHeight - (margin * 2)

      // Ensure we have positive values
      const randomLeft = availableWidth > 0 ? random(margin, margin + availableWidth) : margin
      const randomTop = availableHeight > 0 ? random(margin, margin + availableHeight) : margin

      frame.style.left = randomLeft + 'px'
      frame.style.top = randomTop + 'px'

      // Fade in the frame after positioning
      setTimeout(() => {
        frame.classList.add('visible')
      }, 50)
    }

    // Wait for image to load before initializing
    // Add extra delay on mobile to ensure layout is stable
    const initDelay = isMobile ? 150 : 100

    if (img) {
      if (img.complete && img.naturalWidth > 0) {
        setTimeout(initializeFrame, initDelay)
      } else {
        img.addEventListener('load', () => {
          setTimeout(initializeFrame, initDelay)
        })
      }
    } else {
      setTimeout(initializeFrame, initDelay)
    }

    // Helper function to get coordinates from mouse or touch event
    const getEventCoordinates = (event) => {
      if (event.touches && event.touches.length > 0) {
        return { x: event.touches[0].pageX, y: event.touches[0].pageY }
      }
      return { x: event.pageX, y: event.pageY }
    }

    const startDrag = (event) => {
      z = z + 1
      frame.style.zIndex = z

      let l = frame.offsetLeft
      let t = frame.offsetTop

      const startCoords = getEventCoordinates(event)
      let startX = startCoords.x
      let startY = startCoords.y

      const drag = (event) => {
        event.preventDefault()

        const containerRect = heroCollage.getBoundingClientRect()
        const containerWidth = containerRect.width
        const containerHeight = containerRect.height
        const frameWidth = frame.offsetWidth
        const frameHeight = frame.offsetHeight

        const coords = getEventCoordinates(event)

        // Calculate new position
        let newLeft = l + (coords.x - startX)
        let newTop = t + (coords.y - startY)

        // Allow dragging past edges but keep at least 50px of the frame visible
        const minVisible = 50
        const minLeft = -(frameWidth - minVisible)
        const maxLeft = containerWidth - minVisible
        const minTop = -(frameHeight - minVisible)
        const maxTop = containerHeight - minVisible

        // Constrain position
        newLeft = Math.max(minLeft, Math.min(maxLeft, newLeft))
        newTop = Math.max(minTop, Math.min(maxTop, newTop))

        frame.style.left = newLeft + 'px'
        frame.style.top = newTop + 'px'
      }

      const endDrag = () => {
        document.removeEventListener('mousemove', drag)
        document.removeEventListener('mouseup', endDrag)
        document.removeEventListener('touchmove', drag)
        document.removeEventListener('touchend', endDrag)
      }

      document.addEventListener('mousemove', drag)
      document.addEventListener('mouseup', endDrag)
      document.addEventListener('touchmove', drag, { passive: false })
      document.addEventListener('touchend', endDrag)
    }

    frame.addEventListener('mousedown', startDrag)
    frame.addEventListener('touchstart', startDrag, { passive: true })

    const startResize = (event) => {
      event.stopPropagation()

      let w = frame.clientWidth
      let h = frame.clientHeight
      let aspectRatio = w / h

      const startCoords = getEventCoordinates(event)
      let startX = startCoords.x
      let startY = startCoords.y

      // Different resize limits for mobile vs desktop
      const isMobile = window.innerWidth <= 768
      const minWidth = isMobile ? 75 : 150
      const maxWidth = isMobile ? 150 : 300

      const drag = (event) => {
        event.preventDefault()

        const coords = getEventCoordinates(event)
        let newWidth = w + (coords.x - startX)

        // Constrain width between min and max
        newWidth = Math.max(minWidth, Math.min(maxWidth, newWidth))

        let newHeight = newWidth / aspectRatio

        frame.style.width = newWidth + 'px'
        frame.style.height = newHeight + 'px'
      }

      const endResize = () => {
        document.removeEventListener('mousemove', drag)
        document.removeEventListener('mouseup', endResize)
        document.removeEventListener('touchmove', drag)
        document.removeEventListener('touchend', endResize)
      }

      document.addEventListener('mousemove', drag)
      document.addEventListener('mouseup', endResize)
      document.addEventListener('touchmove', drag, { passive: false })
      document.addEventListener('touchend', endResize)
    }

    corner.addEventListener('mousedown', startResize)
    corner.addEventListener('touchstart', startResize, { passive: true })
  })
})
